import BMapProxy from '@/common/BMapProxy.js'
const Map = function (v, dom) {
  const vue = v
  var active = undefined
  // 初始化map
  var map
  var view
  const proxy = new BMapProxy()
  proxy.init(dom).then((m, v) => {
    map = m
    view = v
    // map.setMapType(BMAP_EARTH_MAP)
    proxy.fly2(117.17425174628049, 32.48339622720056, 13).then(() => {})
  })
  /**
   * 函数：创建一个新的面。在当前地图范围内新生成一个新的面，并将其设为可编辑状态。之前处于可编辑状态的任何要素，转为不可编辑状态。
   */
  this.createPolygon = function (path) {
    // 现有活动的覆盖物设置为非编辑状态
    if (active) {
      active.disableEditing()
    }
    if (!path) {
      const {
        lng,
        lat
      } = map.getCenter()
      const {
        width,
        height
      } = map.getBounds().toSpan()
      path = [
        new BMapGL.Point(lng - width * 0.2, lat + height * 0.2),
        new BMapGL.Point(lng + width * 0.2, lat + height * 0.2),
        new BMapGL.Point(lng + width * 0.2, lat - height * 0.2),
        new BMapGL.Point(lng - width * 0.2, lat - height * 0.2)
      ]
    }
    // 利用中心点坐标和视口宽高，生成一个初始的矩形面（略小于当前视口，宽高各取当前视口的40%）
    active = new BMapGL.Polygon(path, {
      strokeColor: 'blue',
      strokeWeight: 4,
      strokeOpacity: 0.5
    })
    map.addOverlay(active)
    active.enableEditing()
    return {
      type: active._className,
      key: active.hashCode
    }
  }

  /**
   * 函数： 激活某一个要素，使其转为可编辑状态。之前处于可编辑状态的任何要素，转为不可编辑状态。
   * */
  this.activate = function (key) {
    // 现有活动的覆盖物设置为非编辑状态
    if (active) {
      active.disableEditing()
    }
    active = map.getOverlays().find(overlay => {
      return overlay.hashCode == key
    })
    if (active) {
      active.enableEditing()
      const bounds = active.getBounds()
      const center = bounds.getCenter()
      map.panTo(center)
    }
  }

  /**
   * 函数：删除正在编辑的线，返回被删除的线的key（也就是hashCode）
   * */
  this.outlineRemove = function () {
    if (active) {
      const key = active.hashCode
      map.removeOverlay(active)
      setTimeout(() => {
        const overlays = map.getOverlays()
        if (overlays && overlays.length > 0) {
          active = overlays[overlays.length - 1]
          const bounds = active.getBounds()
          const center = bounds.getCenter()
          map.panTo(center)
          active.enableEditing()
        }
      })
      return key
    }
  }

  /**
   * 导入参考对象
   * */
  this.createByCoordinates = function (content) {
    const coordinates = JSON.parse(content)
    if (!Array.isArray(coordinates)) {
      return undefined
    }
    const path = coordinates.map((c) => {
      return new BMapGL.Point(c[0], c[1])
    })
    return path[0].equals(path[path.length - 1]) ? this.createPolygon(path) : this.createLine(path)
  }

  /**
   * 函数：在当前地图范围内新生成一条线，并将其设为可编辑状态。之前处于可编辑状态的任何要素，转为不可编辑状态。
   */
  this.createLine = function (path) {
    // 现有活动的覆盖物设置为非编辑状态
    if (active) {
      active.disableEditing()
    }
    if (!path) {
      const {
        lng,
        lat
      } = map.getCenter()
      const {
        width
      } = map.getBounds().toSpan()
      path = [
        new BMapGL.Point(lng - width * 0.3, lat),
        new BMapGL.Point(lng + width * 0.3, lat),
      ]
    }
    active = new BMapGL.Polyline(path, {
      strokeColor: 'blue',
      strokeWeight: 4,
      strokeOpacity: 0.5
    })
    map.addOverlay(active)
    active.enableEditing()

    return {
      type: active._className,
      key: active.hashCode
    }
  }

  /**
   * 生成json
   * */
  this.jsonString = function () {
    if (active) {
      return active.getPath().map((item) => {
        return [item.lng, item.lat]
      })
    }
    return undefined
  }

  /**
   * 销毁地图
   */
  this.destroy = function () {
    if (map) {
      // TODO 销毁地图
    }
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/_util/Geo.js